import React from 'react';
import { AlertCircle, RefreshCw, Home } from 'lucide-react';

const ErrorScreen = ({
    title = "Something Went Wrong",
    message = "We encountered an error while loading this report. Please try again.",
    onRetry,
    onGoHome,
    showHomeButton = false,
    isRetrying = false
}) => {
    return (
        <div className="flex items-center justify-center min-h-[60vh] px-4">
            <div className="max-w-md w-full text-center">
                {/* Error Icon */}
                <div className="mx-auto w-20 h-20 mb-6 rounded-full bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center">
                    <AlertCircle className="w-10 h-10 text-red-500" strokeWidth={2} />
                </div>

                {/* Error Title */}
                <h2 className="text-2xl font-bold text-gray-900 mb-3">
                    {title}
                </h2>

                {/* Error Message */}
                <p className="text-gray-600 text-base mb-8 leading-relaxed">
                    {message}
                </p>

                {/* Action Buttons - Try Again commented out */}
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    {/* {onRetry && (
                        <button
                            onClick={onRetry}
                            disabled={isRetrying}
                            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-[#1F4B55] text-white font-medium hover:bg-[#163840] transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-sm"
                        >
                            <RefreshCw className={`w-5 h-5 ${isRetrying ? 'animate-spin' : ''}`} />
                            {isRetrying ? 'Retrying...' : 'Try Again'}
                        </button>
                    )} */}

                    {showHomeButton && onGoHome && (
                        <button
                            onClick={onGoHome}
                            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-gray-100 text-gray-700 font-medium hover:bg-gray-200 transition-colors shadow-sm"
                        >
                            <Home className="w-5 h-5" />
                            Go to Home
                        </button>
                    )}
                </div>

                {/* Additional Help Text */}
                <p className="text-sm text-gray-500 mt-6">
                    If the problem persists, please contact support.
                </p>
            </div>
        </div>
    );
};

export default ErrorScreen;
